import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { FlexBox } from "../Boxes";
import Icon from "../Icons";
import { DialogActions, DialogContent, IconButton } from "@mui/material";
import { color } from "../Theme";
import { brandKey } from "../../brand";

// TLScare gets a light header with a bottom border; GPS Care keeps its solid primary header.
const LIGHT_HEADER = brandKey === "tlscare";

export default function FormDialog({
  $open,
  $handleDialog,
  $maxWidth,
  $fullWidth,
  $style,
  children,
  $title,
  $fullScreen,
  $disableHeader,
  $headerColor,
  $actions,
}) {
  const light = LIGHT_HEADER && !$headerColor;
  const foreground = light ? color("heading") : "white";
  return (
    <div>
      <Dialog
        open={$open}
        onClose={$handleDialog}
        maxWidth={$maxWidth}
        fullWidth={$fullWidth}
        style={$style}
        fullScreen={$fullScreen}
      >
        {!$disableHeader && <FlexBox
          $justifyContent="space-between"
          $backgroundColor={light ? "surface" : ($headerColor ?? "primary")}
          $height="56px"
          $borderBottom={light ? `1px solid ${color("border")}` : undefined}
          $paddingLeft={light ? 2 : 0}
          $paddingRight={light ? 2 : 0}
        >
          <DialogTitle style={{ color: foreground, fontSize: 18, fontWeight: 700 }}>{$title}</DialogTitle>
          {light ? (
            <IconButton aria-label="Close" onClick={() => $handleDialog()} size="small" style={{ color: color("text-muted") }}>
              <Icon $icon="Close" $size="20px" $color="inherit" />
            </IconButton>
          ) : (
            <Icon
              $icon="Close"
              $color="white"
              $paddingRight={2}
              $onClick={() => $handleDialog()}
              $pointer="pointer"
              $style
            />
          )}
        </FlexBox>}
        <DialogContent style={{ padding: 0 }}>
          {children}
        </DialogContent>
        {$actions && <DialogActions style={{ padding: "12px 24px", borderTop: `1px solid ${color("border")}` }}>{$actions}</DialogActions>}
      </Dialog>
    </div>
  );
}
